import { testimonials } from '@/mocks/site';

export default function AboutSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-accent-600">
            <span className="inline-block h-2 w-2 rounded-full bg-accent-500"></span>关于我们
          </p>
          <h2 className="font-heading mt-3 text-2xl leading-tight text-foreground-950 md:text-4xl">
            做最懂追更人的漫画更新平台
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            策驰漫画网始终聚焦一件事：让追更不再错过。我们围绕同步更新进度与汉化进度建设了一套清晰的内容体系，
            热门连载最新话上线即推送、更新状态实时同步，帮助每一位读者第一时间掌握抢先看内容。
          </p>
          <ul className="mt-6 space-y-3 text-sm text-foreground-700">
            <li className="flex items-center gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className="ri-flashlight-fill"></i>
              </span>
              更新同步快：最新话上线实时同步，抢先看优先展示
            </li>
            <li className="flex items-center gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className="ri-refresh-line"></i>
              </span>
              进度透明：同步更新进度与汉化进度全程可查
            </li>
            <li className="flex items-center gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className="ri-notification-3-line"></i>
              </span>
              提醒贴心：更新即提醒，追更不再错过任何一话
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-bold text-foreground-950">读者口碑</h3>
          <div className="mt-4 grid grid-cols-1 gap-4">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-lg border border-background-200 bg-background-50 p-4"
              >
                <blockquote className="text-sm leading-relaxed text-foreground-700">
                  “{t.content}”
                </blockquote>
                <figcaption className="mt-3 flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={`${t.name} 头像`}
                    title={`${t.name} - 追更用户`}
                    className="h-10 w-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}